import { isPPLFrontend } from '@root/src/utils/app-paths';

export const DATE_FORMAT = isPPLFrontend ? 'YYYY-MM-DD' : 'YYYY-MM-DDTHH:mm:ss.SSS';
